import { useEffect, useRef, useState } from "react";
import { FaCog } from "react-icons/fa";
import { AppButton } from "../../_CORE/APP/Templates/_UI/Button/_index";
import { AppPopover, PopoverDivider, PopoverItem, PopoverTitle } from "../../_CORE/APP/Templates/_UI/Popover/_index";
import "./_Styles/CardActionMenu.css";

/*
    Menú contextual canónico para cards/archivos.

    La acción principal que ayuda a reconocer el registro (por ejemplo Preview)
    puede quedar visible. Editar, descargar, compartir, destacar y eliminar van
    dentro del engrane para que las cards no terminen llenas de botones.
*/
export const CardActionMenu = ({
    title = "Opciones",
    items = [],
    size = "sm",
    ariaLabel = "Opciones",
    className = "",
    popoverClassName = "",
}) => {
    const REF__anchor = useRef(null);
    const REF__menuId = useRef(`card-action-menu-${Date.now()}-${Math.random().toString(36).slice(2)}`);
    const [useIsOpen, setIsOpen] = useState(false);

    // Un solo engrane abierto en toda la interfaz. Abrir uno cierra los demas,
    // incluso si pertenecen a cards distintas dentro de un modal fullscreen.
    useEffect(() => {
        const onOtherMenuOpen = (event) => {
            if (event?.detail?.id !== REF__menuId.current) setIsOpen(false);
        };
        window.addEventListener("notebook:card-action-menu-open", onOtherMenuOpen);
        return () => window.removeEventListener("notebook:card-action-menu-open", onOtherMenuOpen);
    }, []);

    const onToggleMenu = () => {
        setIsOpen((current) => {
            const next = !current;
            if (next) {
                window.dispatchEvent(new CustomEvent("notebook:card-action-menu-open", {
                    detail: { id: REF__menuId.current },
                }));
            }
            return next;
        });
    };

    const onRun = (item) => {
        if (item?.isDisabled) return;
        setIsOpen(false);
        item?.onClick?.();
    };

    return (
        <div className={`LStudio__app_card_action_menu ${className}`.trim()}>
            <AppButton ref={REF__anchor} size={size} variant="ghost" tone="neutral"
                isIconOnly icon={<FaCog />} aria-label={ariaLabel}
                data-open={useIsOpen ? "true" : undefined}
                onClick={onToggleMenu} />

            <AppPopover isOpen={useIsOpen} onClose={() => setIsOpen(false)}
                anchorRef={REF__anchor} align="end" role="menu" width={245} className={popoverClassName}>
                {title && <PopoverTitle>{title}</PopoverTitle>}
                {items.map((item, index) => item?.divider
                    ? <PopoverDivider key={`divider_${index}`} />
                    : (
                        <PopoverItem key={item?.key ?? `${item?.label ?? "item"}_${index}`}
                            icon={item?.icon ?? null}
                            tone={item?.tone ?? "neutral"}
                            isDisabled={!!item?.isDisabled}
                            onClick={() => onRun(item)}>
                            {item?.label}
                        </PopoverItem>
                    ))}
            </AppPopover>
        </div>
    );
};
